var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Visitor")]),_c('datatable',{staticClass:"superuser-datatable",attrs:{"id":"table-visitor","config":_vm.config,"settingFilters":_vm.settingFilters,"defaultFilter":_vm.defaultFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }